import { Observable } from 'rxjs';

export function getTenantFromUrl(): string | null {
  return /\/org\/([^/]+)/.exec(window.location.href)?.[1] ?? null;
}

/**
 * Converts a URL to a File object by fetching the content
 * @param url - The URL to fetch the file from
 * @param filename - The desired filename for the File object
 * @returns Observable<File | null> - Observable that emits the File object or null on error
 */
export function convertUrlToFile(
  url: string,
  filename: string
): Observable<File | null> {
  return new Observable((observer) => {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch file');
        }
        return response.blob();
      })
      .then((blob) => {
        const file = new File([blob], filename, { type: blob.type });
        observer.next(file);
        observer.complete();
      })
      .catch((error: unknown) => {
        console.error('Error converting URL to File:', error);
        observer.next(null);
        observer.complete();
      });
  });
}
